export const movieDetails = 
    {
        "movieName": "The Rocky Horror Picture Show",
        "imageUrl": "assets/Movies/TheRockyHorrorPictureShow.jpg",
        "movieDescription": "A newly engaged couple have a breakdown in an isolated area and must pay a call to the bizarre residence of Dr. Frank-N-Furter.",
        "movieRating": "4.5",
        "duration":"1:38",
        "movieReleasedYear": "1975",
        "Director":"Jim Sharman",
        "Producer":"Lou Adler, Michael White",
        "Actress":"Susan Sarandon",
        "Actors":"Tim Curry",
        "SupportingActor":"Barry Bostwick",
        "Music":"Gerry Rafferty",
        "Cinematography":"John Coquillon",
        "Editing":"John Coquillon",
        "Studio":"20th Century Fox",
        "Distributor":"20th Century Fox"
    };